export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <span className="text-xl font-heading font-bold text-accent-400">窝窝影院</span>
            <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
              免费高清追剧平台，每日更新最新电视剧全集，超清流畅无广告，追剧首选。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">首页</a>
              <a href="#ranking" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">热播榜单</a>
              <a href="#cards" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">精选剧集</a>
              <a href="#carousel" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">焦点专题</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">内容分类</h4>
            <div className="flex flex-col gap-2">
              <a href="#index" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">剧集索引</a>
              <a href="#topics" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">热门话题</a>
              <a href="#updates" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">更新动态</a>
              <a href="#faq" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-400">优质内容合作方持续接入中</p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2020-2026 窝窝影院 wowo.tv All Rights Reserved.
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-400 cursor-pointer hover:text-accent-400 transition-colors whitespace-nowrap">用户协议</span>
            <span className="text-xs text-foreground-400 cursor-pointer hover:text-accent-400 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="text-xs text-foreground-400 cursor-pointer hover:text-accent-400 transition-colors whitespace-nowrap">版权声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}